import React, { CSSProperties } from 'react';
import { useQuery } from 'react-query';
import { noop } from 'lodash';

import {
  getprOfferList,
  //getOfferListByCatalogID,
  getprOfferListByPrcodeAndMgid,
  prFilteringCriteria
} from '../../../services/pricing';
import Select, { SelectProps } from 'antd/lib/select';

export type OfferInputProps = SelectProps<any> & {
  params: UseOfferListParams;
  disabled?: boolean;
  style?: CSSProperties;
};

const OfferInput = ({
  params,
  onChange = noop,
  value,
  ...otherProps
}: OfferInputProps) => {
  const { data: offers, isFetching: isLoading } = useOfferList(params);

  return (
    <Select
      loading={isLoading}
      value={isNaN(value) || Number(value) === 0 ? '' : Number(value)}
      onChange={onChange}
      {...otherProps}
    >
      {offers?.map((offer) => (
        <Select.Option value={offer.offerid} key={offer.offerid}>
          {offer.offerlabel}
        </Select.Option>
      ))}
    </Select>
  );
};

type UseOfferListParams = {
  catalogid?: number;
  duration?: number;
  filtersList?: prFilteringCriteria;
  filters?: string;
  finamount?: number;
  prcode?: string;
  searchMode: string; // PRCODE : by prcode, CATALOG : bu Catalog, FIN : by FinaMount and Duration
};

const useOfferList = (params: UseOfferListParams) => {
  const {
    prcode,
    duration,
    finamount,
    filters = '',
    filtersList,
    searchMode
  } = params;

  const getOfferListRequest = useQuery(
    ['getOfferList', { duration, filters, finamount, prcode }],
    () =>
      getprOfferList({
        duration: duration!,
        filters,
        finamount: finamount!,
        prcode: prcode!
      }).then((res) => res.list || []),
    { enabled: searchMode === 'FIN' }
  );

  /* const getOfferListByCatalogIDRequest = useQuery(
    ['getOfferListByCatalogID', { catalogid, filters, prcode }],
    () =>
      getOfferListByCatalogID({
        catalogid: catalogid!,
        filters,
        prcode: prcode!,
      }).then((res) => res.list || []),
    { enabled: searchMode === 'CATALOG' }
  );
*/
  const getOfferListByPrcodeAndMgidRequest = useQuery(
    ['getOfferListByPrcodeAndMgid', { filtersList, prcode }],
    () =>
      getprOfferListByPrcodeAndMgid({
        filters: filtersList!
      }).then((res) => res.list || []),
    { enabled: searchMode === 'PRCODE' }
  );

  switch (searchMode) {
    case 'FIN':
      return getOfferListRequest;

    /*  case 'CATALOG':
      return getOfferListByCatalogIDRequest;
*/
    case 'PRCODE':
      return getOfferListByPrcodeAndMgidRequest;
    default:
      return getOfferListByPrcodeAndMgidRequest;
  }
};

export default OfferInput;
